(() => {
'use strict';
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const all = s => [...document.querySelectorAll(s)];
const post = async data => {const r=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});if(!r.ok)throw Error('Cart update failed');return r.json();};
let discountPending = false;
let nativeCartPending = false;
const cartTitles = new Map();
const applicable = (cart, code) => (cart.discount_codes || []).some(discount =>
  typeof discount.code === 'string' && discount.code.toLowerCase() === code.toLowerCase() && discount.applicable === true);
function syncCouponState(cart) {
  all('[data-bp-coupon-button]').forEach(button => {
    const selected = applicable(cart, button.dataset.code);
    button.setAttribute('aria-pressed', String(selected));
    button.classList.toggle('is-selected', selected);
    const label = button.querySelector('[data-bp-coupon-label]');
    if (label) label.textContent = selected ? button.dataset.selected : button.dataset.unselected;
  });
}
function syncDiscountSummary(cart) {
  all('[data-cart-item]').forEach(item => {
    const title = item.querySelector('[data-cart-item-title]');
    const saved = cartTitles.get(item.dataset.cartItem.split(':')[0]);
    if (title && saved) title.textContent = saved;
  });
  const checkout = document.querySelector('.cart-checkout');
  if (!checkout) return;
  const original = Number(cart.original_total_price);
  const final = Number(cart.total_price);
  const savings = Number.isFinite(original) && Number.isFinite(final) ? Math.max(0, original - final) : Number(cart.total_discount || 0);
  let list = checkout.querySelector('.cart-discount');
  if (!(savings > 0)) { if (list) list.remove(); return; }
  if (!list) { list = document.createElement('ul'); list.className = 'cart-discount'; checkout.prepend(list); }
  const entry = document.createElement('li');
  entry.className = 'cart-discount--applications';
  const title = document.createElement('span');
  title.className = 'cart-discount--title';
  const strings = document.querySelector('[data-bp-code-entry], [data-bp-coupon]');
  title.textContent = strings ? strings.dataset.savingsLabel : checkout.dataset.savingsLabel;
  const amount = document.createElement('span');
  amount.className = 'cart-discount--amount';
  amount.textContent = ' −' + new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: cart.currency || 'USD'}).format(savings / 100);
  entry.append(title, amount);
  list.replaceChildren(entry);
  list.hidden = false;
  list.style.display = '';
}
function syncCart(cart) {
  if (window.CartJS && window.CartJS.cart && typeof window.CartJS.cart.update === 'function') window.CartJS.cart.update(cart);
  if (window.jQuery && document.querySelector('[data-section-type="cart-template"]')) {
    window.jQuery(document).trigger('cart.requestComplete', [cart]);
  } else if (window.StyleHatch && window.StyleHatch.AjaxCart) {
    window.StyleHatch.AjaxCart.updateCartButton(cart);
  }
  syncCouponState(cart);
  syncDiscountSummary(cart);
  document.dispatchEvent(new CustomEvent('bp:cart-updated', {detail: cart}));
}
function lockCart() {
  all('[data-bp-code-apply], [data-bp-code-entry] input, [data-cart-item-quantity], [data-cart-item-quantity-plus], [data-cart-item-quantity-minus], .cart-form [name="checkout"], .cart-form [name="update"]').forEach(element => {
    element.dataset.bpCouponDisabled = String(element.disabled);
    element.disabled = true;
  });
  return () => all('[data-bp-coupon-disabled]').forEach(element => {
    element.disabled = element.dataset.bpCouponDisabled === 'true';
    delete element.dataset.bpCouponDisabled;
  });
}
async function applyCode(button, box, code) {
  const status = box.querySelector('[role="status"]');
  if (!code || discountPending) return;
  if (nativeCartPending) {
    status.textContent = box.dataset.pending;
    return;
  }
  discountPending = true;
  const unlock = lockCart();
  all('[data-bp-coupon-button]').forEach(control => control.setAttribute('aria-busy', 'true'));
  button.setAttribute('aria-busy', 'true');
  status.textContent = box.dataset.pending;
  try {
    const cart = await post({discount: code});
    syncCart(cart);
    status.textContent = applicable(cart, code) ? box.dataset.confirmed : box.dataset.ineligible;
  } catch (_) {
    status.textContent = box.dataset.error;
  } finally {
    discountPending = false;
    unlock();
    all('[data-bp-coupon-button]').forEach(control => control.removeAttribute('aria-busy'));
    button.removeAttribute('aria-busy');
  }
}
function init(){
 all('[data-cart-item]').forEach(item => {
   const title = item.querySelector('[data-cart-item-title]');
   if (title) cartTitles.set(item.dataset.cartItem.split(':')[0], title.textContent);
 });
 if (window.jQuery) {
   window.jQuery(document).on('cart.requestStarted.bpCoupon', () => { nativeCartPending = true; });
   window.jQuery(document).on('cart.requestComplete.bpCoupon', (_, cart) => { nativeCartPending = false; if (cart) { syncCouponState(cart); syncDiscountSummary(cart); } });
 }
 document.addEventListener('click', event => {
   if (discountPending && event.target.closest('[data-cart-item-remove]')) { event.preventDefault(); event.stopImmediatePropagation(); }
 }, true);
 document.addEventListener('submit', event => {
   if (discountPending && event.target.matches('.cart-form')) { event.preventDefault(); event.stopImmediatePropagation(); }
 }, true);
 document.addEventListener('click', event => {
   const button = event.target.closest('[data-bp-coupon-button], [data-bp-code-apply]');
   if (!button) return;
   event.preventDefault();
   const box = button.closest('[data-bp-coupon], [data-bp-code-entry]');
   const input = box.querySelector('input');
   const code = input ? input.value.trim() : button.dataset.code;
   if (!code) { if (input) input.focus(); return; }
   applyCode(button, box, code);
 });
 document.addEventListener('keydown', event => {
   if (event.target.matches('[data-bp-code-entry] input') && event.key === 'Enter') {
     event.preventDefault();
     event.target.closest('[data-bp-code-entry]').querySelector('[data-bp-code-apply]').click();
   } else if (event.target.matches('[data-bp-coupon-button]') && event.key === ' ') {
     event.preventDefault();
     event.target.click();
   }
 });
 const restoreCoupon = () => {
   if (!document.querySelector('[data-bp-coupon-button]') || discountPending) return;
   fetch(root + 'cart.js', {headers: {'Accept': 'application/json'}})
     .then(response => { if (!response.ok) throw Error('Cart unavailable'); return response.json(); })
     .then(syncCouponState).catch(() => {});
 };
 window.addEventListener('pageshow', restoreCoupon);
 restoreCoupon();
 const gift=document.querySelector('[data-bp-gift]');let saving=Promise.resolve();
 if(gift){const fields=document.querySelector('[data-bp-gift-fields]');const save=()=>{if(fields)fields.hidden=!gift.checked;const attrs={'Gift order':gift.checked?'Yes':'No'};all('[data-bp-gift-field]').forEach(f=>attrs[f.name.slice(11,-1)]=gift.checked?f.value:'');
 saving=saving.catch(()=>{}).then(()=>post({attributes:attrs})).then(()=>{document.querySelector('[data-bp-gift-status]').textContent=gift.dataset.success;}).catch(()=>{document.querySelector('[data-bp-gift-status]').textContent=gift.dataset.error;});};gift.addEventListener('change',save);all('[data-bp-gift-field]').forEach(f=>f.addEventListener('change',save));}
 all('[data-bp-sticky-purchase]').forEach(bar=>{const original=document.getElementById('AddToCart-'+bar.dataset.section),button=bar.querySelector('[data-bp-sticky-add]');if(!original)return;
 const update=()=>{bar.hidden=!(matchMedia('(max-width: 767px)').matches&&original.getBoundingClientRect().bottom<0);button.disabled=original.disabled;button.textContent=original.textContent.trim();const price=document.getElementById('ProductPrice-'+bar.dataset.section);if(price)bar.querySelector('[data-bp-sticky-price]').textContent=price.textContent.trim();};
 button.addEventListener('click',()=>{if(!original.disabled)original.click();});new IntersectionObserver(update).observe(original);new MutationObserver(update).observe(original,{attributes:true,childList:true,subtree:true});window.addEventListener('resize',update,{passive:true});let scheduled=false;window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;update();});}},{passive:true});document.addEventListener('change',update);update();});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
